import React, { useEffect, useRef } from 'react';
import ApexCharts from 'apexcharts';

const RadialPatientsChart = ({ totalPatients = 0, newPatientsThisMonth = 0 }) => {
  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null);

  useEffect(() => {
    if (chartRef.current) {
      // Destroy existing chart if any
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
      }

      const existingPatients = totalPatients - newPatientsThisMonth;
      const donutChartOptions = {
        chart: {
          height: 290,
          width: '100%',
          type: 'donut',
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '50%',
          },
        },
        dataLabels: {
          enabled: false,
        },
        series: [existingPatients > 0 ? existingPatients : 0, newPatientsThisMonth],
        labels: ['Съществуващи', 'Нови този месец'],
        colors: ['#2E37A4', '#00d4ff'],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: '100%',
              },
              legend: {
                position: 'bottom',
              },
            },
          },
        ],
        legend: {
          position: 'bottom',
        },
      };

      chartInstanceRef.current = new ApexCharts(chartRef.current, donutChartOptions);
      chartInstanceRef.current.render();
    }

    return () => {
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
        chartInstanceRef.current = null;
      }
    };
  }, [totalPatients, newPatientsThisMonth]);

  return <div ref={chartRef}></div>;
};

export default RadialPatientsChart;
